var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"value":_vm.currentValue,"disabled":_vm.disabled,"placeholder":"请选择","change-on-select":"","transfer":true,"data":_vm.dataList},on:{"on-change":_vm._change}})}
var staticRenderFns = []

export { render, staticRenderFns }